/**
 * Automatic knowledge-base search (`config.kbAutoSearch`) is offered only to an
 * agent with a knowledge base that holds a ready file: with nothing to find it
 * would add $0.01/min to the call and slow every turn. The bot runs it only then
 * too (pipecat shared/kb_auto.py `enabled`), and the Angular editor shows the
 * switch on the same rule (features/assistant/editor/kb-auto-search.ts).
 */

import type { KnowledgeBase } from "@/services/knowledge-base.service";

export function hasReadyKnowledgeBase(
  stores: Pick<KnowledgeBase, "id" | "ready_count">[],
  assignedIds: string[],
): boolean {
  return stores.some((store) => assignedIds.includes(store.id) && store.ready_count > 0);
}
